import React, { useEffect, useState, createElement } from 'react';
import { Star, Check, ChevronDown, ArrowRight, ShieldCheck, Users, BookOpen, X, Clock, FileText, Palette, FolderOpen } from 'lucide-react';
import { BonusCard } from './components/BonusCard';
import { TestimonialCard } from './components/TestimonialCard';
import { PurchasePopup } from './components/PurchasePopup';
import { CountdownTimer } from './components/CountdownTimer';
function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleCheckout = () => {
    window.location.href = 'https://checkout15.recursospro.shop/cart/44926459019455:1';
  };
  const openPopup = () => setIsPopupOpen(true);
  // Meta Pixel tracking
  useEffect(() => {
    // Check if fbq already exists
    if ((window as any).fbq) return;
    // Load Facebook Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => {
      // Initialize pixel after script loads
      if ((window as any).fbq) {
        ;
        (window as any).fbq('init', '25912314311727305');
        (window as any).fbq('track', 'PageView');
      }
    };
    (window as any).fbq = function () {
      ;
      (window as any).fbq.callMethod ? (window as any).fbq.callMethod.apply((window as any).fbq, arguments) : (window as any).fbq.queue.push(arguments);
    };
    (window as any).fbq.push = (window as any).fbq;
    (window as any).fbq.loaded = true;
    (window as any).fbq.version = '2.0';
    (window as any).fbq.queue = [];
    // Append script to document
    document.head.appendChild(script);
    return () => {
      // Cleanup
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-blue-100" data-id="element-0">
      {/* Meta Pixel noscript */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=25912314311727305&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <CountdownTimer data-id="element-3" />

      {/* Hero Section */}
      <header className="bg-white pt-4 pb-6 px-4 border-b border-slate-100 relative overflow-hidden" data-id="element-4">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] bg-blue-50/50 rounded-full blur-3xl -z-10 opacity-60" data-id="element-5"></div>

        <div className="max-w-4xl mx-auto text-center" data-id="element-6">
          {/* Badge */}
          <div className="flex justify-center mb-3" data-id="element-7">
            <span className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-800 px-4 py-1.5 rounded-full text-sm font-bold border border-yellow-200 shadow-sm" data-id="element-8">
              🎨 Para docentes de Arte
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-slate-900 mb-3 leading-[1.1] tracking-tight uppercase" data-id="element-9">
            MegaPack Artística Lista
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-2xl text-slate-600 font-medium max-w-2xl mx-auto mb-2 leading-relaxed" data-id="element-10">
            Todo el material de Arte que necesitás, listo para usar.
          </p>

          <p className="text-base md:text-lg text-slate-500 max-w-2xl mx-auto mb-4 leading-relaxed" data-id="element-11">
            Clases creativas, ordenadas y sin pasar horas preparando. Dejá de
            empezar desde cero cada semana.
          </p>

          {/* Product Image - REDUCED SIZE */}
          <div className="relative max-w-[280px] md:max-w-[320px] mx-auto mb-4 group cursor-pointer" onClick={scrollToPurchase} data-id="element-12">
            <div className="absolute inset-0 bg-blue-200 rounded-full blur-2xl opacity-20 group-hover:opacity-30 transition-opacity" data-id="element-13"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ii8qQWiRx4aNkJEZSXHaMr/pasted-image.png" alt="MegaPack Artística Lista" className="w-full relative z-10 transform transition-transform duration-500 group-hover:scale-105 drop-shadow-2xl" data-id="element-14" />
          </div>

          {/* CTA Button */}
          <div className="max-w-lg mx-auto mb-4" data-id="element-15">
            <button onClick={scrollToPurchase} className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-black text-lg md:text-xl py-4 px-6 rounded-lg shadow-[0_6px_0_rgb(21,128,61)] hover:shadow-[0_4px_0_rgb(21,128,61)] active:shadow-[0_2px_0_rgb(21,128,61)] active:translate-y-[4px] transition-all uppercase tracking-wide" data-id="element-16">
              👉 SÍ, QUIERO ACCEDER AHORA
            </button>
            <p className="text-slate-500 text-xs mt-2 flex items-center justify-center gap-1.5" data-id="element-17">
              <ShieldCheck className="w-3.5 h-3.5 text-green-500" data-id="element-18" />
              Garantía de satisfacción de 7 días
            </p>
          </div>
        </div>
      </header>

      {/* Question Section */}
      <section className="py-16 px-4 bg-slate-50" data-id="element-19">
        <div className="max-w-3xl mx-auto text-center" data-id="element-20">
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-21">
            Si enseñás Arte, dejame hacerte una pregunta honesta
          </h2>
          <p className="text-xl md:text-2xl text-slate-700 font-medium mb-4" data-id="element-22">
            ¿Te pasa que preparar la clase te cansa más que darla?
          </p>
          <div className="text-base md:text-lg text-slate-600 space-y-3 max-w-2xl mx-auto leading-relaxed" data-id="element-23">
            <p data-id="element-24">No porque no te guste enseñar. No porque no tengas vocación.</p>
            <p className="font-medium" data-id="element-25">
              Sino porque cada clase parece empezar desde cero.
            </p>
            <p data-id="element-26">
              Buscar ideas. Pensar actividades. Armar materiales. Ordenar
              recursos sueltos.
            </p>
            <p className="text-slate-700 font-semibold mt-6" data-id="element-27">
              Y cuando finalmente entrás al aula… ya estás cansado/a.
            </p>
            <p className="text-xl font-bold text-slate-900 mt-8" data-id="element-28">
              Enseñar Arte no debería sentirse así.
            </p>
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-white" data-id="element-29">
        <div className="max-w-4xl mx-auto" data-id="element-30">
          <div className="text-center mb-12" data-id="element-31">
            <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4" data-id="element-32">
              El problema que nadie dice en voz alta
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-33">
              Si sos docente de Arte, esto seguramente te resulta familiar:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-34">
            <div className="bg-slate-50 p-6 rounded-xl border border-slate-200" data-id="element-35">
              <div className="flex items-start gap-3" data-id="element-36">
                <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" data-id="element-37" />
                <p className="text-slate-700" data-id="element-38">
                  Pasás horas pensando qué actividad hacer
                </p>
              </div>
            </div>
            <div className="bg-slate-50 p-6 rounded-xl border border-slate-200" data-id="element-39">
              <div className="flex items-start gap-3" data-id="element-40">
                <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" data-id="element-41" />
                <p className="text-slate-700" data-id="element-42">
                  Tenés ideas, pero están desordenadas
                </p>
              </div>
            </div>
            <div className="bg-slate-50 p-6 rounded-xl border border-slate-200" data-id="element-43">
              <div className="flex items-start gap-3" data-id="element-44">
                <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" data-id="element-45" />
                <p className="text-slate-700" data-id="element-46">
                  Buscás inspiración en mil lugares distintos
                </p>
              </div>
            </div>
            <div className="bg-slate-50 p-6 rounded-xl border border-slate-200" data-id="element-47">
              <div className="flex items-start gap-3" data-id="element-48">
                <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" data-id="element-49" />
                <p className="text-slate-700" data-id="element-50">
                  Guardás PDFs, fotos y links que después no encontrás
                </p>
              </div>
            </div>
            <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 md:col-span-2" data-id="element-51">
              <div className="flex items-start gap-3" data-id="element-52">
                <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" data-id="element-53" />
                <p className="text-slate-700" data-id="element-54">
                  Terminás improvisando más de lo que te gustaría
                </p>
              </div>
            </div>
          </div>

          <div className="bg-slate-50 border-2 border-slate-200 rounded-2xl p-8 text-center" data-id="element-55">
            <p className="text-lg md:text-xl text-slate-700 font-medium italic" data-id="element-56">
              Lo peor es esa sensación constante de:{' '}
              <span className="text-slate-900 font-bold not-italic" data-id="element-57">
                "Podría dar mejores clases… si tuviera el material listo."
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-16 px-4 bg-blue-600 text-white" data-id="element-58">
        <div className="max-w-4xl mx-auto text-center" data-id="element-59">
          <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-bold mb-6" data-id="element-60">
            ✅ La solución
          </div>
          <h2 className="text-3xl md:text-5xl font-black mb-6" data-id="element-61">
            MegaPack Artística Lista
          </h2>
          <p className="text-lg md:text-xl text-blue-100 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-62">
            Un sistema completo de recursos de Arte, diseñado para que dejes de
            empezar desde cero y vuelvas a disfrutar enseñar.
          </p>

          <div className="grid md:grid-cols-3 gap-8 max-w-3xl mx-auto" data-id="element-63">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20" data-id="element-64">
              <div className="text-5xl mb-4" data-id="element-65">📂</div>
              <h3 className="font-bold text-lg mb-2" data-id="element-66">Abrís el material</h3>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20" data-id="element-67">
              <div className="text-5xl mb-4" data-id="element-68">👆</div>
              <h3 className="font-bold text-lg mb-2" data-id="element-69">Elegís una actividad</h3>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20" data-id="element-70">
              <div className="text-5xl mb-4" data-id="element-71">🎨</div>
              <h3 className="font-bold text-lg mb-2" data-id="element-72">La aplicás en clase</h3>
            </div>
          </div>

          <p className="text-xl font-bold mt-12" data-id="element-73">
            Sin vueltas. Sin improvisar. Sin perder tiempo.
          </p>
        </div>
      </section>

      {/* What's Included Section */}
      <section className="py-20 px-4 bg-white" data-id="element-74">
        <div className="max-w-4xl mx-auto" data-id="element-75">
          <div className="text-center mb-12" data-id="element-76">
            <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6" data-id="element-77">
              🎨 ¿Qué incluye exactamente el MegaPack?
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-78">
            <div className="flex items-start gap-3 bg-slate-50 p-6 rounded-xl" data-id="element-79">
              <Check className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-80" />
              <p className="text-slate-700 font-medium" data-id="element-81">
                Más de 1000 actividades creativas
              </p>
            </div>
            <div className="flex items-start gap-3 bg-slate-50 p-6 rounded-xl" data-id="element-82">
              <Check className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-83" />
              <p className="text-slate-700 font-medium" data-id="element-84">
                Técnicas artísticas explicadas paso a paso
              </p>
            </div>
            <div className="flex items-start gap-3 bg-slate-50 p-6 rounded-xl" data-id="element-85">
              <Check className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-86" />
              <p className="text-slate-700 font-medium" data-id="element-87">
                Recursos visuales claros y atractivos
              </p>
            </div>
            <div className="flex items-start gap-3 bg-slate-50 p-6 rounded-xl" data-id="element-88">
              <Check className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-89" />
              <p className="text-slate-700 font-medium" data-id="element-90">
                Fichas y materiales imprimibles
              </p>
            </div>
            <div className="flex items-start gap-3 bg-slate-50 p-6 rounded-xl" data-id="element-91">
              <Check className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-92" />
              <p className="text-slate-700 font-medium" data-id="element-93">
                Secuencias didácticas completas
              </p>
            </div>
            <div className="flex items-start gap-3 bg-slate-50 p-6 rounded-xl" data-id="element-94">
              <Check className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-95" />
              <p className="text-slate-700 font-medium" data-id="element-96">
                Proyectos listos para trabajar durante el año
              </p>
            </div>
            <div className="flex items-start gap-3 bg-slate-50 p-6 rounded-xl md:col-span-2" data-id="element-97">
              <Check className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-98" />
              <p className="text-slate-700 font-medium" data-id="element-99">
                Todo organizado para encontrar rápido lo que necesitás
              </p>
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-100">
            <button onClick={scrollToPurchase} className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-slate-900 font-black text-base px-8 py-3.5 rounded-lg shadow-[0_4px_0_rgb(161,98,7)] hover:shadow-[0_2px_0_rgb(161,98,7)] active:shadow-none active:translate-y-[4px] transition-all uppercase tracking-wide" data-id="element-101">
              👉 ACCEDER CON DESCUENTO
            </button>
          </div>
        </div>
      </section>

      {/* Before/After Section */}
      <section className="py-20 px-4 bg-slate-50" data-id="element-102">
        <div className="max-w-5xl mx-auto" data-id="element-103">
          <h2 className="text-3xl md:text-4xl font-black text-center text-slate-900 mb-16" data-id="element-104">
            Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-105">
            {/* Before */}
            <div className="bg-white rounded-2xl p-8 border-2 border-red-200" data-id="element-106">
              <div className="flex items-center gap-3 mb-6" data-id="element-107">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center" data-id="element-108">
                  <X className="w-6 h-6 text-red-600" data-id="element-109" />
                </div>
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-110">
                  Antes del MegaPack
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-111">
                <li className="flex items-start gap-3" data-id="element-112">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-113" />
                  <span className="text-slate-700" data-id="element-114">
                    Improvisación constante
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-115">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-116" />
                  <span className="text-slate-700" data-id="element-117">Cansancio mental</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-118">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-119" />
                  <span className="text-slate-700" data-id="element-120">Clases repetidas</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-121">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-122" />
                  <span className="text-slate-700" data-id="element-123">Poco tiempo para crear</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-124">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-125" />
                  <span className="text-slate-700" data-id="element-126">
                    Estrés antes de cada clase
                  </span>
                </li>
              </ul>
            </div>

            {/* After */}
            <div className="bg-white rounded-2xl p-8 border-2 border-green-200 relative" data-id="element-127">
              <div className="absolute -top-3 -right-3 bg-green-500 text-white px-4 py-1 rounded-full text-sm font-bold shadow-lg" data-id="element-128">
                ¡Mejor!
              </div>
              <div className="flex items-center gap-3 mb-6" data-id="element-129">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-130">
                  <Check className="w-6 h-6 text-green-600" data-id="element-131" />
                </div>
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-132">
                  Después del MegaPack
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-133">
                <li className="flex items-start gap-3" data-id="element-134">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-135" />
                  <span className="text-slate-700 font-medium" data-id="element-136">
                    Clases claras y organizadas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-137">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-138" />
                  <span className="text-slate-700 font-medium" data-id="element-139">
                    Material listo siempre
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-140">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-141" />
                  <span className="text-slate-700 font-medium" data-id="element-142">
                    Más creatividad
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-143">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-144" />
                  <span className="text-slate-700 font-medium" data-id="element-145">
                    Más disfrute
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-146">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-147" />
                  <span className="text-slate-700 font-medium" data-id="element-148">
                    Menos estrés
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 bg-white" data-id="element-149">
        <div className="max-w-6xl mx-auto" data-id="element-150">
          <div className="text-center mb-16" data-id="element-151">
            <span className="text-blue-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-152">
              🎁 Regalos especiales
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-4" data-id="element-153">
              BONOS INCLUIDOS HOY
            </h2>
            <p className="text-slate-500 text-lg" data-id="element-154">(Sin costo adicional)</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-155">
            <BonusCard number={1} title="Planificaciones listas" description="Modelos claros y organizados para aplicar sin pensar ni rehacer." image="https://cdn.magicpatterns.com/uploads/vvmSt87SvfxjzQjfF7pPJ2/pasted-image.png" data-id="element-156" />
            <BonusCard number={2} title="Libros digitales de Arte" description="Material visual sobre técnicas, artistas y movimientos." image="https://cdn.magicpatterns.com/uploads/2uU4xk9Y3WuGFuQucJhz7P/pasted-image.png" data-id="element-157" />
            <BonusCard number={3} title="Proyectos completos" description="Propuestas listas para trabajar durante todo el año." image="https://cdn.magicpatterns.com/uploads/sdqo2Zg7e8wk497gNpndNv/pasted-image.png" data-id="element-158" />
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="purchase" className="py-20 px-4 bg-slate-900 text-white relative overflow-hidden" data-id="element-159">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-160">
          <div className="absolute top-10 left-10 w-64 h-64 bg-blue-600 rounded-full blur-[100px] opacity-20" data-id="element-161"></div>
          <div className="absolute bottom-10 right-10 w-64 h-64 bg-blue-500 rounded-full blur-[100px] opacity-20" data-id="element-162"></div>
        </div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-163">
          <div className="text-center mb-12" data-id="element-164">
            <div className="inline-block bg-yellow-400 text-slate-900 px-4 py-2 rounded-full text-sm font-bold mb-4" data-id="element-165">
              ⏰ Oferta por tiempo limitado
            </div>
            <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-166">
              Accedé a todo el MegaPack Artística Lista
            </h2>
            <p className="text-xl text-slate-300" data-id="element-167">+ los 3 Bonos de regalo</p>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-12 text-slate-900 max-w-2xl mx-auto" data-id="element-168">
            {/* What's Included Box */}
            <div className="bg-blue-50 border-2 border-blue-200 rounded-2xl p-6 mb-8" data-id="element-169">
              <h3 className="font-black text-lg text-slate-900 mb-4 text-center" data-id="element-170">
                📦 Lo que vas a recibir hoy:
              </h3>
              <div className="space-y-3" data-id="element-171">
                <div className="flex items-start gap-3" data-id="element-172">
                  <Check className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-173" />
                  <span className="text-slate-700 font-medium" data-id="element-174">
                    <strong data-id="element-175">5 Libros Digitales</strong> listos para imprimir con
                    técnicas, artistas y movimientos
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-176">
                  <Check className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-177" />
                  <span className="text-slate-700 font-medium" data-id="element-178">
                    <strong data-id="element-179">Bono #1:</strong> Planificaciones listas para todo
                    el año
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-180">
                  <Check className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-181" />
                  <span className="text-slate-700 font-medium" data-id="element-182">
                    <strong data-id="element-183">Bono #2:</strong> Material visual sobre técnicas
                    artísticas
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-184">
                  <Check className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-185" />
                  <span className="text-slate-700 font-medium" data-id="element-186">
                    <strong data-id="element-187">Bono #3:</strong> Proyectos completos para trabajar
                    durante el año
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-188">
                  <Check className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-189" />
                  <span className="text-slate-700 font-medium" data-id="element-190">
                    Más de <strong data-id="element-191">1000 actividades creativas</strong>{' '}
                    organizadas y listas
                  </span>
                </div>
              </div>
            </div>

            <div className="text-center mb-8" data-id="element-192">
              <span className="text-slate-400 line-through text-2xl block mb-4" data-id="element-193">
                Precio regular: $49.990 ARS
              </span>
              <div className="flex flex-col items-center gap-2 mb-4" data-id="element-194">
                <span className="bg-blue-600 text-white font-bold px-4 py-2 rounded-lg text-sm uppercase tracking-wider" data-id="element-195">
                  HOY SOLO
                </span>
                <div className="flex flex-col items-center" data-id="element-196">
                  <span className="text-6xl md:text-7xl font-black text-blue-600 tracking-tighter" data-id="element-197">
                    $19.990
                  </span>
                  <span className="text-sm text-slate-500 mt-2 font-medium" data-id="element-198">
                    *Pesos argentinos
                  </span>
                </div>
              </div>
            </div>

            <div className="space-y-3 mb-8" data-id="element-199">
              <div className="flex items-center gap-3 text-slate-700" data-id="element-200">
                <Check className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-201" />
                <span className="font-medium" data-id="element-202">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-3 text-slate-700" data-id="element-203">
                <Check className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-204" />
                <span className="font-medium" data-id="element-205">Un solo pago</span>
              </div>
              <div className="flex items-center gap-3 text-slate-700" data-id="element-206">
                <Check className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-207" />
                <span className="font-medium" data-id="element-208">Descarga digital</span>
              </div>
            </div>

            <button onClick={handleCheckout} className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-black text-xl md:text-2xl py-5 px-8 rounded-lg shadow-[0_8px_0_rgb(21,128,61)] hover:shadow-[0_6px_0_rgb(21,128,61)] active:shadow-[0_2px_0_rgb(21,128,61)] active:translate-y-[6px] transition-all mb-6 uppercase tracking-wide" data-id="element-209">
              👉 OBTENER MI MEGAPACK HOY
            </button>

            <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 text-center" data-id="element-210">
              <h4 className="font-bold text-slate-900 mb-2 flex items-center justify-center gap-2" data-id="element-211">
                <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-212" />
                Garantía sin riesgo
              </h4>
              <p className="text-sm text-slate-600 leading-relaxed" data-id="element-213">
                Probalo durante 7 días. Si no es para vos, te devolvemos el 100%
                del dinero.
                <br data-id="element-214" />
                <span className="font-semibold" data-id="element-215">
                  Sin preguntas. Sin letra chica.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-slate-50" data-id="element-216">
        <div className="max-w-6xl mx-auto" data-id="element-217">
          <h2 className="text-3xl md:text-4xl font-black text-center text-slate-900 mb-16" data-id="element-218">
            Lo que dicen otros docentes
          </h2>
          <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-219">
            <TestimonialCard name="María Fernández" role="Profesora de Primaria, Buenos Aires" content="Ahora entro a clase sabiendo exactamente qué hacer. Me devolvió la tranquilidad que necesitaba." data-id="element-220" />
            <TestimonialCard name="Carlos Rodríguez" role="Docente de Secundaria, Córdoba" content="Me ahorró muchísimo tiempo. Antes tardaba horas en planificar, ahora en minutos tengo todo listo." data-id="element-221" />
            <TestimonialCard name="Ana Martínez" role="Maestra de Arte, Rosario" content="Las clases fluyen mejor y los chicos participan más. El material es súper visual y atractivo." data-id="element-222" />
          </div>
          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-223">
            <TestimonialCard name="José López" role="Profesor de Plástica, Mendoza" content="Es la mejor inversión que hice para mi trabajo. Material de calidad y muy bien organizado." data-id="element-224" />
            <TestimonialCard name="Laura García" role="Docente de Inicial, La Plata" content="No es teoría aburrida. Es práctica real que funciona en el aula con chicos de verdad." data-id="element-225" />
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 bg-white" data-id="element-226">
        <div className="max-w-3xl mx-auto" data-id="element-227">
          <h2 className="text-3xl md:text-4xl font-black text-center text-slate-900 mb-12" data-id="element-228">
            Preguntas frecuentes
          </h2>
          <div className="space-y-4" data-id="element-229">
            {[{
            q: '¿Es material digital?',
            a: 'Sí. Acceso y descarga inmediata a tu correo electrónico.'
          }, {
            q: '¿Sirve para cualquier nivel educativo?',
            a: 'Sí. Está pensado y adaptado para todos los niveles educativos.'
          }, {
            q: '¿Funciona para clases presenciales y online?',
            a: 'Sí, perfectamente. Los recursos son adaptables a ambas modalidades.'
          }, {
            q: '¿Necesito experiencia previa?',
            a: 'No. Todo está explicado paso a paso para que puedas aplicarlo fácilmente.'
          }].map((faq, i) => <div key={i} className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-230">
                <button onClick={() => toggleAccordion(i)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-slate-50 transition-colors" data-id="element-231">
                  <span className="font-bold text-slate-900 text-lg" data-id="element-232">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform ${activeAccordion === i ? 'rotate-180' : ''}`} data-id="element-233" />
                </button>
                {activeAccordion === i && <div className="p-6 pt-0 bg-white text-slate-600 leading-relaxed border-t border-slate-100" data-id="element-234">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4 bg-blue-600 text-white" data-id="element-235">
        <div className="max-w-3xl mx-auto text-center" data-id="element-236">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-237">
            Enseñar Arte puede ser más simple
          </h2>
          <p className="text-xl text-blue-100 mb-8" data-id="element-238">
            No necesitás más ideas. Necesitás un sistema que te sostenga.
          </p>
          <button onClick={scrollToPurchase} className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-slate-900 font-black text-lg px-10 py-4 rounded-lg shadow-[0_6px_0_rgb(161,98,7)] hover:shadow-[0_4px_0_rgb(161,98,7)] active:shadow-[0_2px_0_rgb(161,98,7)] active:translate-y-[4px] transition-all uppercase tracking-wide" data-id="element-239">
            👉 Accedé ahora al MegaPack Artística Lista
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-12 px-4 text-center border-t border-slate-800" data-id="element-240">
        <div className="max-w-4xl mx-auto" data-id="element-241">
          <p className="mb-4 font-medium" data-id="element-242">
            © 2026 MegaPack Artística Lista. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 text-sm" data-id="element-243">
            <a href="#" className="hover:text-white transition-colors" data-id="element-244">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-245">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </footer>

      <PurchasePopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-246" />
    </div>;
}
export { App };